import Vue from 'vue'

const Environment = function () {}
Environment.PROD = 'prod'
Environment.STAGING = 'staging'
Environment.DEV = 'dev'
Environment.env = null

Environment.getEnv = function () {
    if (Environment.env === null) {
        if (window.location.host === 'app.pdfshift.io' || window.location.host === 'my.pdfshift.io') {
            this.setEnv(this.PROD)
        } else if (window.location.hostname === '127.0.0.1') {
            this.setEnv(this.DEV)
        }
    }
    return Environment.env
}
Environment.setEnv = function (env) {
    console.log('Working on ' + env.toUpperCase() + ' environment.')
    this.env = env
    switch (env) {
        case this.PROD:
            window.stripe_api_key = 'pk_live_Nu7cMuvIDlk7gHcksvN52v5S'
            break
        default:
            window.stripe_api_key = 'pk_test_N1Lori9EgMNMzWplqBUHcVlB'
            break
    }
}

Environment.testEndpoint = async function (baseUrl) {
    try {
        const response = await Vue.http.get(baseUrl + '/ping')
        return (response.data.toLowerCase().indexOf('pdfshift') > -1)
    } catch (e) {
        return false
    }
}
Environment.getAPIUrl = async function () {
    const customUrl = Vue.storage.get('api_url')
    if (customUrl) {
        // Checking that the endpoint is a valid Reachful API server
        const baseUrl = customUrl.substr(0, customUrl.indexOf('/', 10))
        if (await Environment.testEndpoint(baseUrl)) {
            console.info('Using custom URL: ', customUrl)
            this.setEnv(Environment.DEV)
            return customUrl
        }
    }

    if (this.getEnv() === this.PROD) {
        return 'https://api.pdfshift.io/v3/'
    } else {
        if (await Environment.testEndpoint('http://127.0.0.1:5000')) {
            console.info('Using DEV http://127.0.0.1:5000/v3/')
            this.setEnv(Environment.DEV)
            return 'http://127.0.0.1:5000/v3/'
        }

        console.warn('Using PROD /!\\ https://api.pdfshift.io/v3/')
        this.setEnv(Environment.PROD)
        return 'https://api.pdfshift.io/v3/'
    }
}

export default Environment
